import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import { connect } from "react-redux";
import { Grid, Badge, Button, Divider, MenuItem, TextField, Typography, Box, Menu } from "@material-ui/core";
import { Add, DoubleArrow, FileCopy, Replay, GetApp } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import "./SciencificResearchButton.css";
import ScientificResearchInsertModal from "../ScientificResearchInsertModal";
import ScientificResearchUpdateModal from "../ScientificResearchUpdateModal";
import ScientificResearchCheckDuplicateModal from "../ScientificResearchCheckDuplicateModal";
import ScientificResearchExportModal from "../ScientificResearchExportModal";

import {
  setFilter,
  getAllPurpose,
  getAllScientificResearchById,
  getFilteredScientificResearch,
  getDuplicateScientificResearch,
  exportScientificResearch,
} from "../../../reducer/scientificResearch/action";
import { getAllProfile } from "../../../reducer/profile/action";
import {
  getAllScientificResearchOtherByProfileId,
  getAllScientificResearchOther,
} from "../../../reducer/scientificResearchOther/action";
import { KPTextform } from "../../../components/KPTComponents";

import { exportExcel } from "../utils/exportExcel";

function ScientificResearchButton(props) {
  const {
    getAllProfile,
    getAllScientificResearchById,
    getFilteredScientificResearch,
    getAllScientificResearchOther,
    getAllScientificResearchOtherByProfileId,
    getDuplicateScientificResearch,
    type,
    department,
    handleReload: onReload,
    date,
    setDate,
  } = props;

  const [inserting, setInserting] = useState(false);
  const [checking, setChecking] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [updating, setUpdating] = useState(null);

  const profileId = useMemo(() => {
    return props.selectedProfileId || props.profile?.id;
  }, [props.selectedProfileId, props.profile?.id]);

  // Ref để đảm bảo useEffect chỉ chạy 1 lần
  const hasInitialized = useRef(false);

  const listFilter = useMemo(
    () => [
      {
        value: "journalInternational",
        type: "scientificResearchJournal",
        title: "Tạp chí quốc tế",
        unacceptedNum: props.statisticUnacceptedDetailFilter?.numJournal,
        checkFunction: (e) =>
          e.scientificResearch.type === "scientificResearchJournal" && !e.scientificResearch.accepted,
      },
      {
        value: "journalDomestic",
        type: "scientificResearchJournalDomestic",
        title: "Tạp chí trong nước",
        unacceptedNum: props.statisticUnacceptedDetailFilter?.numDomesticJournal,
        checkFunction: (e) => e.journalDomestic && !e.scientificResearch.accepted,
      },
      {
        value: "conference",
        type: "scientificResearchConference",
        title: "Hội thảo quốc tế",
        unacceptedNum: props.statisticUnacceptedDetailFilter?.numConference,
        // checkFunction: (e) =>
        //   e.conference?.level === "international" && !e.scientificResearch.accepted,
        checkFunction: (e) =>
          e.scientificResearch.type === "scientificResearchConference" && !e.scientificResearch.accepted,
      },
      {
        value: "conferenceDomestic",
        type: "scientificResearchConferenceDomestic",
        title: "Hội thảo trong nước",
        unacceptedNum: props.statisticUnacceptedDetailFilter?.numDomesticConference,
        // checkFunction: (e) =>
        //   e.conference?.level === "domestic" && !e.scientificResearch.accepted,
        checkFunction: (e) =>
          e.scientificResearch.type === "scientificResearchConferenceDomestic" && !e.scientificResearch.accepted,
      },
      // {
      //   value: "chapter",
      //   type: "chapterJournal",
      //   title: "Chương sách",
      //   unacceptedNum: props.statisticUnacceptedDetailFilter?.numBook,
      //   checkFunction: (e) => e.scientificResearch.type === "chapterJournal" && !e.scientificResearch.accepted,
      // },
      // {
      //   value: "workingPaper",
      //   type: "working",
      //   title: "Working Paper",
      //   unacceptedNum: 0,
      //   checkFunction: (e) => false,
      // },
      // {
      //   value: "other",
      //   type: "scientificResearchOther",
      //   title: "Tạp chí khác",
      //   unacceptedNum: props.statisticUnacceptedDetailFilter?.numOther,
      //   checkFunction: (e) => e.scientificResearch.type === "scientificResearchOther" && !e.scientificResearch.accepted,
      // },
    ],
    [props.statisticUnacceptedDetailFilter],
  );

  // Lấy mục đích - chỉ chạy 1 lần khi component mount
  useEffect(() => {
    if (props.purposes.length === 0 && !props.isFetchingPurposes) props.getAllPurpose();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Lấy danh sách profile - chỉ chạy 1 lần khi component mount
  useEffect(() => {
    if (props.listProfile.length === 0 && !props.isFetchingProfile) getAllProfile();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Lấy dữ liệu khi vào tab lần đầu
  useEffect(() => {
    if (type !== "all" && profileId && !hasInitialized.current) {
      getAllScientificResearchById(profileId);
      hasInitialized.current = true;
    }
  }, [type, profileId, getAllScientificResearchById]);

  // Đổi department thì lấy lại dữ liệu
  // Nếu chậy lần đầu department rỗng thì không get api ko thì sẽ get cả trường
  useEffect(() => {
    // // // console.log(props.department);
    if (!props.other) {
      if (props.department !== null && props.department !== undefined)
        getFilteredScientificResearch(1, -1, {
          departmentId: props.department,
        });
    }
  }, [props.department, props.other, getFilteredScientificResearch]);

  const handleReload = useCallback(() => {
    if (type === "all") {
      getFilteredScientificResearch(1, -1, { departmentId: department });
      if (onReload) onReload();
    } else {
      if (onReload) onReload();
      getAllScientificResearchById(profileId);
    }
  }, [type, department, onReload, getFilteredScientificResearch, getAllScientificResearchById, profileId]);

  const handleInsert = useCallback(() => setInserting(true), []);

  const handleCheckDuplicate = useCallback(() => {
    getDuplicateScientificResearch();
    setChecking(true);
  }, [getDuplicateScientificResearch]);

  const handleExport = useCallback(() => {
    setExporting(true);
  }, []);

  const handleExportData = useCallback(
    async (payload) => {
      await props.exportScientificResearch(payload);
      setExporting(false);
    },
    [props],
  );

  const list = useMemo(() => {
    return props.type === "all" ? props.listFilteredScientificResearch : props.listScientificResearchById;
  }, [props.type, props.listFilteredScientificResearch, props.listScientificResearchById]);

  return (
    <>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={5}>
          <Typography variant="h5" style={{ lineHeight: "36px" }}>
            Công trình nghiên cứu
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <TextField
            select
            fullWidth
            size="small"
            variant="outlined"
            SelectProps={{
              MenuProps: {
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "center",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "center",
                },
                getContentAnchorEl: null,
              },
            }}
            InputProps={{ style: { display: "flex", flexDirection: "row" } }}
            value={props.filter}
            onChange={(e) => {
              props.setFilter(e.target.value);
            }}
          >
            {listFilter.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                <Badge
                  className="sr-badge"
                  color="error"
                  badgeContent={
                    !props?.adminTab ? list?.filter((e) => option.checkFunction(e)).length : option.unacceptedNum
                  }
                >
                  {option.title}
                </Badge>
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={5}>
          <div style={{ float: "right" }}>
            <Button variant="outlined" startIcon={<Replay />} onClick={handleReload}>
              Tải lại
            </Button>
            {props.type === "all" && props.role === "sudo-admin" && (
              <Button
                variant="outlined"
                color="primary"
                startIcon={<FileCopy />}
                style={{ marginLeft: 8 }}
                onClick={handleCheckDuplicate}
              >
                Check trùng
              </Button>
            )}
            {props.type === "all" && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<FileCopy />}
                style={{ marginLeft: 8 }}
                onClick={(event) => props.setAnchorEl(event.currentTarget)}
              >
                Báo cáo
              </Button>
            )}
            <Button
              variant="contained"
              color="secondary"
              startIcon={<GetApp />}
              style={{ marginLeft: 8 }}
              onClick={handleExport}
            >
              Xuất Excel
            </Button>
            {props.type !== "all" && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                style={{ marginLeft: 8 }}
                onClick={handleInsert}
              >
                Thêm công bố
              </Button>
            )}
          </div>
        </Grid>
        {/* {isFilter && (
          <Grid item xs={9}>
            <KPTextform
              textForm={[
                { xs: 3, key: 'export', type: 'render', render: () => (
                  <Button variant="outlined">Xuất excel báo cáo</Button>
                ) },
                { xs: 2, key: 'startAt', type: 'date' },
                { xs: 1, key: 'to', type: 'render', render: () => (
                  <Box display="flex" justifyContent="center">
                    <DoubleArrow style={{ fontSize: 36, color: "rgba(0, 0, 0, 0.30)" }} />
                  </Box>
                ) },
                { xs: 2, key: 'finishAt', type: 'date' },
                { xs: 2, key: 'export', type: 'render', render: () => (
                  <Button fullWidth variant="outlined" style={{ height: 35 }}>Bỏ lọc</Button>
                ) },
                { xs: 2, key: 'export', type: 'render', render: () => (
                  <Button fullWidth color="primary" variant="contained" style={{ height: 35 }}>Áp dụng</Button>
                ) },
              ]}
              values={date}
              setValues={setDate}
            />
          </Grid>
        )} */}
      </Grid>
      <Divider style={{ margin: "8px 0" }} />
      <ScientificResearchInsertModal
        inserting={inserting}
        filter={props.filter}
        type={listFilter.find((e) => e.value === props.filter)?.type}
        setInserting={setInserting}
        other={props.other}
        onEditDuplicate={(item) => {
          setInserting(false);
          setUpdating(item);
        }}
      />
      <ScientificResearchUpdateModal
        adminTab={props.adminTab}
        filter={props.filter}
        updating={updating}
        setUpdating={setUpdating}
        other={props.other}
        type={listFilter.find((e) => e.value === props.filter)?.type}
      />
      <ScientificResearchCheckDuplicateModal
        open={checking}
        onClose={() => setChecking(false)}
        loading={props.isCheckingDuplicate}
        data={props.listDuplicate}
      />
      <ScientificResearchExportModal
        open={exporting}
        onClose={() => setExporting(false)}
        type={props.type === "all" ? "department" : "personal"}
        profileId={props.type === "all" ? 0 : profileId}
        departmentId={props.type === "all" ? department : 0}
        exportData={handleExportData}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  isFetchingProfile: select(state, "profileReducer", "isFetching"), // ✅ Sửa đúng reducer
  isFetchingPurposes: select(state, "scientificResearchReducer", "isFetchingPurposes"),
  isCheckingDuplicate: select(state, "scientificResearchReducer", "isCheckingDuplicate"),
  isFetchingScientificResearch: select(state, "scientificResearchReducer", "isFetching"),
  isFetchingScientificResearchOther: select(state, "scientificResearchOtherReducer", "isFetching"),

  filter: select(state, "scientificResearchReducer", "filter"),
  profile: select(state, "profileReducer", "detail"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  listProfile: select(state, "profileReducer", "list"),
  listDuplicate: select(state, "scientificResearchReducer", "listDuplicate"),
  reduxDepartment: select(state, "profileReducer", "department"),
  // listScientificResearch: select(state, "scientificResearchReducer", "list"),
  listScientificResearchById: select(state, "scientificResearchReducer", "listById"),
  listScientificResearchOther: select(state, "scientificResearchOtherReducer", "list"),
  listFilteredScientificResearch: select(state, "scientificResearchReducer", "listFiltered"),
  listScientificResearchOtherById: select(state, "scientificResearchOtherReducer", "listById"),
  statisticUnacceptedDetailFilter: select(state, "profileReducer", "statisticUnacceptedDetailFilter"),
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (id) => dispatch(setFilter(id)),
  getAllPurpose: () => dispatch(getAllPurpose()),
  getAllProfile: () => dispatch(getAllProfile()),
  getAllScientificResearchById: (id) => dispatch(getAllScientificResearchById(id)),
  getFilteredScientificResearch: (page, pageSize, payload) =>
    dispatch(getFilteredScientificResearch(page, pageSize, payload)),
  getAllScientificResearchOtherByProfileId: (id) => dispatch(getAllScientificResearchOtherByProfileId(id)),
  getAllScientificResearchOther: (id) => dispatch(getAllScientificResearchOther(id)),
  getDuplicateScientificResearch: () => dispatch(getDuplicateScientificResearch()),
  exportScientificResearch: (payload) => dispatch(exportScientificResearch(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ScientificResearchButton));

